import React, { createContext, useState } from "react";

export const DonationContext = createContext();

export const DonationProvider = ({ children }) => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const triggerRefresh = () => setRefreshFlag(prev => !prev);

  return (
    <DonationContext.Provider value={{ refreshFlag, triggerRefresh }}>
      {children}
    </DonationContext.Provider>
  );
};
